(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name crewValidation.service:crewValidationService
	 * 
	 * @description
	 * 
	 */
	angular.module('crewValidation').service('CrewValidationService',
			CrewValidationService);

	function CrewValidationService(CrewValidationRequestFactory, RemoteService,
			crewScheduleService, CommonMasterData) {

		var self = this;

		// store retrieved data
		var model = {
			validationReq : CrewValidationRequestFactory.getValidationReq(),
			validationSearchRequest : CrewValidationRequestFactory
					.getValidationSearchRequest(),
			crewValidationList : [],
			selectedValidation : CrewValidationRequestFactory.getValidation(),
			saveValidationRequest : CrewValidationRequestFactory
					.getSaveValidationRequest(),
			deleteValidationRequest : CrewValidationRequestFactory
					.getDeleteValidationRequest(),
			acTypesByValidationReq : CrewValidationRequestFactory
					.getACTypeByValidationRequest(),
			crewTypes : [],
			crewList : [],
			validationTypes : [],
			validation : [],
			countries : [],
			bases : [],
			acTypes : []
		};

		// setter and getter of search criteria
		self.setValidationRequest = function(searchParam) {
			model.validationReq = CrewValidationRequestFactory
					.getFormattedValidationRequest(searchParam);
			return model.validationReq;
		};
		self.getNewValidationRequest = function() {
			model.validationReq = CrewValidationRequestFactory
					.getValidationReq();
			return model.validationReq;
		};

		// get search Crew Validations request
		self.setCrewValidationSearchRequest = function(param) {
			model.validationSearchRequest = CrewValidationRequestFactory
					.getFormattedValidationSearchRequest(param); 
		};

		// search crew validations
		self.searchCrewValidations = function(successFn, errorFn) {
			RemoteService
					.getCrewValidations(model.validationSearchRequest)
					.then(
							function(response) {
								if (response.success
										&& !!response.crewValidationDTOs) {
									model.crewValidationList = response.crewValidationDTOs;
									successFn(model.crewValidationList);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		};

		// save crew Validation
		self.saveCrewValidation = function(selectedValidation, successFn,
				errorFn) {
			model.saveValidationRequest = CrewValidationRequestFactory
					.getFormattedSaveValidationRequest(selectedValidation);
			RemoteService.saveCrewValidation(model.saveValidationRequest).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error);
					});
		}

		// delete Crew Validation
		self.deleteCrewValidation = function(selectedValidation, successFn,
				errorFn) {
			model.deleteValidationRequest = CrewValidationRequestFactory
					.getFormattedDeleteValidationRequest(selectedValidation);
			RemoteService.deleteCrewValidation(model.deleteValidationRequest).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error);
					});
		}

		// get validation by setting the selected row data
		self.setSelectedValidation = function(param) {
			model.selectedValidation = CrewValidationRequestFactory
					.getFormattedValidation(param);
			getCrewTypes(param);
			getValidationTypes(param);
			getCrewBases(param);
			getCrewListByCrewType(param.crewType, param);
			getValidationsByValidationType(param);
			getCountries(param);
			//getACTypesByValidation(param);
			getACTypes(param);
			return model.selectedValidation;
		};

		// get validation when new validation to add
		self.getNewValidation = function() {
			model.selectedValidation = CrewValidationRequestFactory
					.getValidation();
			return model.selectedValidation;
		};

		self.setACTypeByValidationRequest = function(selectedValidation) {
			model.acTypesByValidationReq = CrewValidationRequestFactory
					.getFormattedACTypeByValidationRequest(selectedValidation);
			return model.acTypesByValidationReq;
		}

		// get master data lists
		function getCrewTypes(param) {
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				model.crewTypes = crewTypes;
				model.selectedValidation.crewType = _.find(model.crewTypes, {
					crewTypeCode : param.crewType
				});
			}, function() {
				console.log('Crew types retrieval error');
			});
		}
		;

		function getValidationTypes(param) {
			CommonMasterData.getValidationTypeList(function(validationTypes) {
				model.validationTypes = validationTypes;
				model.selectedValidation.validationType = _.find(
						model.validationTypes, {
							code : param.validationTypeCode
						});
			}, function() {
				console.log('Validation types retrieval error');
			});
		}
		;

		function getCrewListByCrewType(crewTypeCode, params) {
			var param = {};
			param.crewType = '';
			param.active = true;
			if (!!crewTypeCode) {
				param.crewType = crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
					model.crewList = crewScheduleService
							.adaptCrewList(response);
					model.selectedValidation.crew = _.find(model.crewList, {
						displayName : params.crewName
					});
				}, function() {
					console.log('Crew list retrieval error');
				});
			} else {
				return [];
			}
		}
		;

		function getValidationsByValidationType(param) {
			// only if req is not defined
			var req = CrewValidationRequestFactory.getValidationReq();
			req.validationType = param.validationTypeCode;
			if (!!req) {
				CommonMasterData.loadValidationList(req, function(response) {
					model.validation = response;
					model.selectedValidation.validation = _.find(
							model.validation, {
								id : parseInt(param.validationId)
							});
				}, function() {
					console.log('Validation List retrieval error');
				});
			} else {
				return [];
			}
		}
		;

		function getCrewBases(param) {
			CommonMasterData.getCrewBaseList(function(crewBases) {
				model.bases = crewBases;
				model.selectedValidation.base = _.find(model.bases, {
					airPortCode : param.crewBase
				});
			}, function() {
				console.log('Crew Base List retrieval error');
			});
		}
		;

		function getACTypes(param) {
			CommonMasterData.getAircraftTypeList(function(aircrafts) {
				model.acTypes = aircrafts; 
				model.selectedValidation.acType = _.find(model.acTypes, {
					modelNumber : param.aircraftType
				});
			}, function() {
				console.log('Aircraft types retrieval error');
			});		
		}
		;
		
		function getACTypesByValidation(param){
			model.acTypesByValidationReq = CrewValidationRequestFactory.getFormattedACTypeByValidationRequest(param);
			CommonMasterData.loadACTypesByValidationList(model.acTypesByValidationReq,
					function(response) {
						if(!!response.aircrafts && response.aircrafts.length>0){
							if(model.acTypes==null || model.acTypes.length<0 ){
								getACTypes();
							}
							model.selectedValidation.acType = _.find(model.acTypes, {
								id : response.aircrafts[0].modelNumber
							});
						}else{
							model.selectedValidation.acType = null
						}
					}, function() {
						console.log('AC Type List by Validation retrieval error');
					});
		}


		function getCountries(param) {
			CommonMasterData
					.getCountryList(
							function(countries) {
								model.countries = countries;
								var countryCodes = [];
								var validatedCountries = [];

								// split country codes
								if (!!param.countryCodes) {
									countryCodes = param.countryCodes
											.split(',');
								}
								// if selected country codes are available
								if (!!countryCodes) {
									for (var countryCode = 0; countryCode < countryCodes.length; countryCode++) {
										var country = _.find(model.countries, {
											code : countryCodes[countryCode]
										});
										if (!!country) {
											validatedCountries.push(country);
										}
									}
								}
								model.selectedValidation.validationCountries = validatedCountries;
							}, function() {
								console.log('Country List retrieval error');
							});

		}
		;
	}
})();